'use strict';

module Patersons {
    export class SizeDetectorService {
        $html: any;
        constructor() {
            this.initSizeDetector();
        }
        private initSizeDetector() {
            console.log("initializing size detector")
            $(document).ready(($) => {
                this.$html = $('html')

                $(window).resize(() => {
                    this.checkWidth();
                });
                //Fire it when the page first loads:
                this.checkWidth();
            });
        }
        private checkWidth() {
            const windowWidth = document.body.clientWidth;
            this.$html.removeClass('table-xSmall table-small table-medium table-large');
            if (windowWidth < 569) {
                return this.$html.addClass('table-small');
              }
              else if (windowWidth >= 569 && windowWidth < 1024) {
                return this.$html.addClass('table-medium');
              }
              else if (windowWidth > 1024) {
                return this.$html.addClass('table-large');
              }
        };
    }
}